import { createRouter, createWebHistory } from 'vue-router';
import MainLayout from '../main/layouts/MainLayout.vue';
import HomePage from '../main/pages/HomePage.vue';
import AdminLayout from '../admin/layouts/AdminLayout.vue';
import LoginLayout from '../admin/layouts/LoginLayout.vue';
import DashboardPage from '../admin/pages/DashboardPage.vue';
import ContingentRegistrationPage from '../admin/pages/ContingentRegistrationPage.vue';
import TournamentInsightPage from '@/admin/pages/dashboard/TournamentInsightPage.vue';
import LoginPage from '../admin/pages/LoginPage.vue';
import LupaSandiPage from '@/admin/pages/LupaSandiPage.vue';
import RegistrationPage from '@/main/pages/RegistrationPage.vue';
import TournamentPage from '@/main/pages/TournamentPage.vue';
import AboutPage from '@/main/pages/AboutPage.vue';
import PrivacyPolicyPage from '@/main/pages/PrivacyPolicyPage.vue';
import SchedulePage from '@/main/pages/SchedulePage.vue';
import GalleryDetail from '@/main/pages/GalleryDetail.vue';
import NotFoundPage from '@/admin/pages/NotFoundPage.vue';
import AdminNavigationList from '../admin/pages/navigation/NavigationList.vue';
import NavigationCreatePage from "@/admin/pages/navigation/NavigationCreatePage.vue";
import NavigationEditPage from "@/admin/pages/navigation/NavigationEditPage.vue";
import AdminContingetList from '../admin/pages/contingent/ContingentList.vue';
import ContingentCreatePage from "@/admin/pages/contingent/ContingentCreatePage.vue";
import ContingentEditPage from "@/admin/pages/contingent/ContingentEditPage.vue";
import AdminTeamMembersList from '../admin/pages/team-members/MembersList.vue';
import TeamMembersCreatePage from "@/admin/pages/team-members/MembersCreatePage.vue";
import TeamMembersEditPage from "@/admin/pages/team-members/MembersEditPage.vue";
import ImporAtletPage from '@/admin/pages/team-members/ImporAtletPage.vue';
import IdCardPage from '@/admin/pages/id-card/IdCardPage.vue';
import PerkiraanMedaliPage from '@/admin/pages/perkiraan-medali/PerkiraanMedaliPage.vue';
import JenisTarifPage from '@/admin/pages/jenis-tarif/JenisTarifPage.vue';
import AdminPaymentList from '../admin/pages/payment/PaymentList.vue';
import PaymentCreatePage from "@/admin/pages/payment/PaymentCreatePage.vue";
import PaymentEditPage from "@/admin/pages/payment/PaymentEditPage.vue";
import PaymentConfirmationPage from "@/admin/pages/payment/PaymentConfirmationPage.vue";
import BuatTagihanPage from "@/admin/pages/payment/BuatTagihanPage.vue";
import TagihanDetailPage from "@/admin/pages/payment/TagihanDetailPage.vue";
import KetersediaanKelasPage from "@/admin/pages/payment/KetersediaanKelasPage.vue";
import ClassesList from '../admin/pages/classes/ClassList.vue';
import ClassesCreatePage from "@/admin/pages/classes/ClassCreatePage.vue";
import ClassesEditPage from "@/admin/pages/classes/ClassEditPage.vue";
import ClasificationList from '@/admin/pages/match-clasification/ClasificationList.vue';
import ClasificationCreatePage from '@/admin/pages/match-clasification/ClasificationCreatePage.vue';
import ClasificationEditPage from '@/admin/pages/match-clasification/ClasificationEditPage.vue';

import DrawingCreatePage from '@/admin/pages/drawing/DrawingCreatePage.vue';
import DrawingEditPage from '@/admin/pages/drawing/DrawingEditPage.vue';
import MatchPage from '@/admin/pages/drawing/MatchPage.vue';
import MatchList from '@/admin/pages/drawing/MatchList.vue';
import DrawingList from '@/admin/pages/drawing/DrawingList.vue';
import MatchChartPage from '@/admin/pages/match-chart/MatchChartPage.vue';
import MatchRecapPage from '@/admin/pages/drawing/MatchRecapPage.vue';


import SeniMatchCreatePage from '@/admin/pages/seni/DrawingCreatePage.vue';
import SeniMatchEditPage from '@/admin/pages/seni/DrawingEditPage.vue';
import SeniMatchPage from '@/admin/pages/seni/MatchPage.vue';
import SeniMatchList from '@/admin/pages/seni/DrawingList.vue';




import TournamentList from '../admin/pages/tournament/TournamentList.vue';
import TurnamenSayaPage from '@/admin/pages/tournament/TurnamenSayaPage.vue';
import { isBendahara, isOwner, isPanitia, isAdminEvent, bolehDibukaBendahara, bolehDibukaAdminEvent, halamanAwal } from '@/utils/peran';
import TournamentCreatePage from "@/admin/pages/tournament/TournamentCreatePage.vue";
import TournamentEditPage from "@/admin/pages/tournament/TournamentEditPage.vue";

import TournamentActivity from '../admin/pages/tournament-activity/TournamentActivityList.vue';
import TournamentActivityCreatePage from "@/admin/pages/tournament-activity/TournamentActivityCreatePage.vue";
import TournamentActivityEditPage from "@/admin/pages/tournament-activity/TournamentActivityEditPage.vue";


import TournamentAgeCategoryCreatePage from '@/admin/pages/tournament-age-category/TournamentAgeCategoryCreatePage.vue';
import TournamentAgeCategoryEditPage from '@/admin/pages/tournament-age-category/TournamentAgeCategoryEditPage.vue';
import TournamentAgeCategoryList from '../admin/pages/tournament-age-category/TournamentAgeCategoryList.vue';

import TournamentArenaList from '@/admin/pages/tournament-arena/TournamentArenaList.vue';
import TournamentArenaCreatePage from '@/admin/pages/tournament-arena/TournamentArenaCreatePage.vue';
import TournamentArenaEditPage from '@/admin/pages/tournament-arena/TournamentArenaEditPage.vue';

import ContactPersonList from '@/admin/pages/tournament-contact-person/ContactPersonList.vue';
import ContactPersonCreatePage from '@/admin/pages/tournament-contact-person/ContactPersonCreatePage.vue';
import ContactPersonEditPage from '@/admin/pages/tournament-contact-person/ContactPersonEditPage.vue';

import TournamentScheduleList from '@/admin/pages/tournament-schedule/TournamentScheduleList.vue';
import TournamentScheduleCreatePage from '@/admin/pages/tournament-schedule/TournamentScheduleCreatePage.vue';
import TournamentScheduleEditPage from '@/admin/pages/tournament-schedule/TournamentScheduleEditPage.vue';


import TournamentScheduleSeniCreatePage from '@/admin/pages/tournament-schedule/TournamentScheduleSeniCreatePage.vue';
import TournamentScheduleSeniEditPage from '@/admin/pages/tournament-schedule/TournamentScheduleSeniEditPage.vue';
import ContingentSchedulePage from '@/admin/pages/tournament-schedule/ContingentSchedulePage.vue';
//import TournamentAgeCategoryCreatePage from '@/admin/pages/tournament-age-category/TournamentAgeCategoryCreatePage.vue';

import SliderList from '@/admin/pages/sliders/SliderList.vue';
import SliderCreatePage from '@/admin/pages/sliders/SliderCreatePage.vue';
import SliderEditPage from '@/admin/pages/sliders/SliderEditPage.vue';

const routes = [
  {
    path: '/',
    component: MainLayout,
    children: [
      { path: '', component: HomePage }
    ]
  },
  {
    path: '/about-us',
    component: MainLayout,
    children: [
      { path: '', component: AboutPage }
    ]
  },
  {
    path: '/privacy-policy',
    component: MainLayout,
    children: [
      { path: '', component: PrivacyPolicyPage }
    ]
  },
  
  /*
   * Pendaftaran akun TIDAK menuntut acara dipilih lebih dulu.
   *
   * `:slug?` membuat bagian acara opsional, jadi /registration langsung
   * membuka formulirnya. Bentuk berslug tetap dipertahankan supaya tautan
   * yang sudah tersebar di grup pelatih tidak mati — dan di situ perkiraan
   * biaya acaranya ikut ditampilkan.
   *
   * Pemilihan acara dipindah ke SETELAH login, di halaman Turnamen Saya,
   * tempat official bisa melihat kontingennya sekaligus.
   */
  {
    path: '/registration/:slug?',
    component: MainLayout,
    children: [
      {
        props: true,
        name: 'registration',
        path: '',
        component: RegistrationPage,
      },
    ],
  },  
  {
    path: '/detail',
    component: MainLayout, // Use MainLayout for all /kejuaraan routes
    children: [
      {
        path: '', // Matches /kejuaraan
        name: 'TournamentPage',
        component: TournamentPage, // TournamentPage as the default view
      },
      {
        path: ':slug', // Matches /kejuaraan/:id
        name: 'GalleryDetail',
        component: GalleryDetail, // GalleryDetail for specific IDs
        props: true, // Pass route params as props
      },
    ],
  },
  
  {
    path: '/schedule',
    component: MainLayout,
    children: [
      { path: '', component: SchedulePage }
    ]
  },
  {
    path: '/admin',
    component: AdminLayout,
    children: [
      { path: '', component: DashboardPage }
    ]
  },
  {
    path: '/contingent-registration/:id',
    component: AdminLayout,
    children: [
      {
        props: true, // Kirim parameter ID ke komponen sebagai props
        name: 'contingent-registration', // Name should be here in the child route
        path: '', // Child route should not redefine ":id"
        component: ContingentRegistrationPage,
      },
    ],
  },  
  {
    path: '/tournament-insight/:id',
    component: AdminLayout,
    children: [
      {
        props: true, // Kirim parameter ID ke komponen sebagai props
        name: 'tournament-insight', // Name should be here in the child route
        path: '', // Child route should not redefine ":id"
        component: TournamentInsightPage,
      },
    ],
  }, 
  {
    path: '/admin/lupa-sandi',
    component: LoginLayout,
    children: [
      { path: '', component: LupaSandiPage }
    ]
  },

  { 
    path: '/admin/login', 
    component: LoginLayout, 
    children: [ 
      { path: '', component: LoginPage } // Use LoginLayout for login page ] }
    ]
  },
  {
    path: '/admin/navigation',
    meta: { hanyaOwner: true },
    component: AdminLayout,
    children: [
      { path: '', component: AdminNavigationList }
    ]
    //meta: { requiresAdmin: true }  // for admin-only route
  },
  {
    path: '/admin/navigation/create',
    meta: { hanyaOwner: true },
    component: AdminLayout,
    children: [
      { path: '', component: NavigationCreatePage }
    ]
    //meta: { requiresAdmin: true }  // admin-only form for menu
  },
  {
    path: '/admin/navigation/edit/:id',
    meta: { hanyaOwner: true },
    component: AdminLayout,
    children: [
      {
        path: '',
        name: "EditMenu",
        component: NavigationEditPage,
        props: true,
      }
    ]
    //meta: { requiresAdmin: true }  // admin-only form for menu
  },
  {
    path: '/admin/contingent',
    component: AdminLayout,
    children: [
      { path: '', component: AdminContingetList }
    ]
    //meta: { requiresAdmin: true }  // for admin-only route
  },
  {
    path: '/admin/contingent/create',
    component: AdminLayout,
    children: [
      { path: '', component: ContingentCreatePage }
    ]
    //meta: { requiresAdmin: true }  // admin-only form for menu
  },
  {
    path: '/admin/contingent/edit/:id',
    component: AdminLayout,
    children: [
      {
        path: '',
        name: 'EditContingent',
        component: ContingentEditPage,
        props: true,
      }
    ]
  },
  {
    path: '/admin/team-members/salin',
    component: AdminLayout,
    children: [
      { path: '', name: 'SalinAtlet', component: () => import('@/admin/pages/team-members/SalinAtletPage.vue') },
    ],
  },
  {
    path: '/admin/status-pendaftaran',
    component: AdminLayout,
    children: [
      { path: '', name: 'StatusPendaftaran', component: () => import('@/admin/pages/team-members/StatusPendaftaranPage.vue') },
    ],
  },
  {
    path: '/admin/team-members/impor',
    component: AdminLayout,
    // Dimatikan sementara untuk official & admin event; hanya super admin.
    meta: { hanyaOwner: true },
    children: [
      { path: '', component: ImporAtletPage }
    ]
  },

  {
    path: '/admin/id-card',
    component: AdminLayout,
    meta: { hanyaPanitia: true },
    children: [
      { path: '', component: IdCardPage }
    ]
  },

  {
    path: '/admin/perkiraan-medali/:id?',
    component: AdminLayout,
    children: [
      {
        path: '',
        name: 'PerkiraanMedali',
        component: PerkiraanMedaliPage,
        props: true,
      }
    ]
  },

  {
    path: '/admin/jenis-tarif',
    component: AdminLayout,
    children: [
      { path: '', component: JenisTarifPage }
    ]
  },

  {
    path: '/admin/team-members',
    component: AdminLayout,
    children: [
      { path: '', component: AdminTeamMembersList }
    ]
    //meta: { requiresAdmin: true }  // for admin-only route
  },
  {
    path: '/admin/team-members/create',
    component: AdminLayout,
    children: [
      { path: '', component: TeamMembersCreatePage }
    ]
    //meta: { requiresAdmin: true }  // admin-only form for menu
  },
  {
    path: '/admin/team-members/edit/:id',
    component: AdminLayout,
    children: [
      {
        path: '',
        name: "EditMember",
        component: TeamMembersEditPage,
        props: true,
      }
    ]
    //meta: { requiresAdmin: true }  // admin-only form for menu
  },
  {
    path: '/admin/payment',
    component: AdminLayout,
    children: [
      { path: '', component: AdminPaymentList }
    ]
    //meta: { requiresAdmin: true }  // for admin-only route
  },
  {
    // Menjawab "kelas ini sudah berapa orang?" — sebelumnya tidak ada caranya.
    path: '/admin/ketersediaan-kelas',
    component: AdminLayout,
    children: [
      {
        path: '',
        name: 'KetersediaanKelas',
        component: KetersediaanKelasPage,
      }
    ]
  },
  {
    // Layar pelatih: ceklis atlet lalu buat tagihan.
    path: '/admin/payment/buat',
    component: AdminLayout,
    children: [
      {
        path: '',
        name: 'BuatTagihan',
        component: BuatTagihanPage,
      }
    ]
  },
  {
    // Detail satu tagihan: rincian atlet, rekening, unggah bukti, verifikasi.
    path: '/admin/payment/:id(\\d+)',
    component: AdminLayout,
    children: [
      {
        path: '',
        name: 'TagihanDetail',
        component: TagihanDetailPage,
        props: true,
      }
    ]
  },
  {
    path: '/admin/payment/create',
    component: AdminLayout,
    children: [
      { path: '', component: PaymentCreatePage }
    ]
    //meta: { requiresAdmin: true }  // admin-only form for menu
  },
  {
    path: '/admin/payment/edit/:id',
    component: AdminLayout,
    children: [
      {
        path: '',
        name: "EditPayment",
        component: PaymentEditPage,
        props: true,
      }
    ]
    //meta: { requiresAdmin: true }  // admin-only form for menu
  },
  {
    path: '/admin/payment/confirm/:id',
    component: AdminLayout,
    children: [
      {
        path: '',
        name: "ConfirmPayment",
        component: PaymentConfirmationPage,
        props: true,
      }
    ]
    //meta: { requiresAdmin: true }  // admin-only form for menu
  },
  {
    path: '/admin/classes',
    meta: { hanyaOwner: true },
    component: AdminLayout,
    children: [
      { path: '', component: ClassesList }
    ]
    //meta: { requiresAdmin: true }  // for admin-only route
  },
  {
    path: '/admin/classes/create',
    meta: { hanyaOwner: true },
    component: AdminLayout,
    children: [
      { path: '', component: ClassesCreatePage }
    ]
    //meta: { requiresAdmin: true }  // admin-only form for menu
  },
  {
    path: '/admin/classes/edit/:id',
    meta: { hanyaOwner: true },
    component: AdminLayout,
    children: [
      {
        path: '',
        name: "EditClass",
        component: ClassesEditPage,
        props: true,
      }
    ]
    //meta: { requiresAdmin: true }  // admin-only form for menu
  },
  {
    path: '/admin/match-clasification',
    component: AdminLayout,
    children: [
      { path: '', component: ClasificationList }
    ]
    //meta: { requiresAdmin: true }  // for admin-only route
  },
  {
    path: '/admin/match-clasification/create',
    component: AdminLayout,
    children: [
      { path: '', component: ClasificationCreatePage }
    ]
    //meta: { requiresAdmin: true }  // admin-only form for menu
  },
  {
    path: '/admin/match-clasification/edit/:id',
    component: AdminLayout,
    children: [
      {
        path: '',
        name: "EditClasification",
        component: ClasificationEditPage,
        props: true,
      }
    ]
    //meta: { requiresAdmin: true }  // admin-only form for menu
  },
  {
    path: '/admin/tanding',
    // Admin event juga boleh: rute API-nya dikunci ke turnamennya sendiri.
    meta: { hanyaPanitia: true },
    component: AdminLayout,
    children: [
      { path: '', component: DrawingList }
    ]
    //meta: { requiresAdmin: true }  // for admin-only route
  },
  {
    path: '/admin/tanding/create',
    // Admin event juga boleh: rute API-nya dikunci ke turnamennya sendiri.
    meta: { hanyaPanitia: true },
    component: AdminLayout,
    children: [
      { path: '', component: DrawingCreatePage }
    ]
    //meta: { requiresAdmin: true }  // admin-only form for menu
  },
  {
    path: '/admin/tanding/edit/:id',
    // Admin event juga boleh: rute API-nya dikunci ke turnamennya sendiri.
    meta: { hanyaPanitia: true },
    component: AdminLayout,
    children: [
      {
        path: '',
        name: "EditDrawing",
        component: DrawingEditPage,
        props: true,
      }
    ]
    //meta: { requiresAdmin: true }  // admin-only form for menu
  },
  {
    path: '/admin/tanding/match/:id',
    // Admin event juga boleh: rute API-nya dikunci ke turnamennya sendiri.
    meta: { hanyaPanitia: true },
    component: AdminLayout,
    children: [
      { 
        path: '',
        name: "GenerateMatch",
        component: MatchPage,
        props: true,
      }
    ]
    //meta: { requiresAdmin: true }  // admin-only form for menu
  },
  {
    path: '/admin/tanding/match/list/:id',
    // Admin event juga boleh: rute API-nya dikunci ke turnamennya sendiri.
    meta: { hanyaPanitia: true },
    component: AdminLayout,
    children: [
      { 
        path: '',
        name: "ViewMatch",
        component: MatchList,
        props: true,
      }
    ]
    //meta: { requiresAdmin: true }  // admin-only form for menu
  },
  {
    path: '/admin/tanding/matches',
    // Admin event juga boleh: rute API-nya dikunci ke turnamennya sendiri.
    meta: { hanyaPanitia: true },
    component: AdminLayout,
    children: [
      {
        path: ':tournament_id',
        name: "MatchRecap",
        component: MatchRecapPage,
        props: true
      }
    ]
  },

   // ✅ SLIDERS ROUTES (NEW)
  {
    path: '/admin/slider-builder',
    meta: { hanyaOwner: true },
    component: AdminLayout,
    children: [
      { path: '', component: SliderList }
    ]
  },
  {
    path: '/admin/sliders',
    meta: { hanyaOwner: true },
    redirect: '/admin/slider-builder'
  },
  {
    path: '/admin/slider-builder/create',
    meta: { hanyaOwner: true },
    component: AdminLayout,
    children: [
      { path: '', component: SliderCreatePage }
    ]
  },
  {
    path: '/admin/sliders/create',
    meta: { hanyaOwner: true },
    redirect: '/admin/slider-builder/create'
  },
  {
    path: '/admin/slider-builder/:id/edit',
    meta: { hanyaOwner: true },
    component: AdminLayout,
    children: [
      {
        path: '',
        name: 'SliderEdit',
        component: SliderEditPage,
        props: true,
      }
    ]
  },
  {
    path: '/admin/sliders/:id/edit',
    meta: { hanyaOwner: true },
    redirect: to => `/admin/slider-builder/${to.params.id}/edit`
  },


  {
    path: '/admin/seni',
    // Admin event juga boleh: rute API-nya dikunci ke turnamennya sendiri.
    meta: { hanyaPanitia: true },
    component: AdminLayout,
    children: [
      { path: '', component: SeniMatchList }
    ]
    //meta: { requiresAdmin: true }  // for admin-only route
  },
  {
    path: '/admin/seni/create',
    // Admin event juga boleh: rute API-nya dikunci ke turnamennya sendiri.
    meta: { hanyaPanitia: true },
    component: AdminLayout,
    children: [
      { path: '', component: SeniMatchCreatePage }
    ]
    //meta: { requiresAdmin: true }  // admin-only form for menu
  },
  {
    path: '/admin/seni/edit/:id',
    // Admin event juga boleh: rute API-nya dikunci ke turnamennya sendiri.
    meta: { hanyaPanitia: true },
    component: AdminLayout,
    children: [
      {
        path: '',
        name: "EditSeniMatch",
        component: SeniMatchEditPage,
        props: true,
      }
    ]
    //meta: { requiresAdmin: true }  // admin-only form for menu
  },
  {
    path: '/admin/seni/match/:id',
    // Admin event juga boleh: rute API-nya dikunci ke turnamennya sendiri.
    meta: { hanyaPanitia: true },
    component: AdminLayout,
    children: [
      { 
        path: '',
        name: "GenerateSeniMatch",
        component: SeniMatchPage,
        props: true,
      }
    ]
    //meta: { requiresAdmin: true }  // admin-only form for menu
  },
  {
    path: '/admin/seni/match/list/:id',
    // Admin event juga boleh: rute API-nya dikunci ke turnamennya sendiri.
    meta: { hanyaPanitia: true },
    component: AdminLayout,
    children: [
      { 
        path: '',
        name: "ViewSeniMatch",
        component: SeniMatchList,
        props: true,
      }
    ]
    //meta: { requiresAdmin: true }  // admin-only form for menu
  },



  {
    path: '/admin/match-chart',
    // Admin event juga boleh: rute API-nya dikunci ke turnamennya sendiri.
    meta: { hanyaPanitia: true },
    component: AdminLayout,
    children: [
      { path: '', component: MatchChartPage }
    ]
    //meta: { requiresAdmin: true }  // admin-only form for menu
  },
  /*
   * Halaman acara untuk OFFICIAL, terpisah dari /admin/tournament yang
   * merupakan CRUD milik panitia. Keduanya disaring lewat peran, jadi
   * official tidak melihat menu panitia dan sebaliknya.
   */
  {
    path: '/admin/turnamen-saya',
    component: AdminLayout,
    children: [
      { path: '', component: TurnamenSayaPage }
    ]
  },

  {
    path: '/admin/tournament',
    component: AdminLayout,
    children: [
      { path: '', component: TournamentList }
    ]
    //meta: { requiresAdmin: true }  // for admin-only route
  },
  {
    path: '/admin/tournament/:id(\\d+)/pengguna',
    component: AdminLayout,
    meta: { hanyaOwner: true },
    children: [
      {
        path: '',
        name: 'PenggunaEvent',
        component: () => import('@/admin/pages/tournament/PenggunaEventPage.vue'),
        props: true,
      }
    ]
  },
  {
    path: '/admin/keuangan',
    component: AdminLayout,
    children: [
      { path: '', name: 'Keuangan', component: () => import('@/admin/pages/keuangan/KeuanganPage.vue') }
    ]
  },
  {
    path: '/admin/tournament/create',
    meta: { hanyaOwner: true },
    component: AdminLayout,
    children: [
      { path: '', component: TournamentCreatePage }
    ]
    //meta: { requiresAdmin: true }  // admin-only form for menu
  },
  {
    path: '/admin/tournament/edit/:id',
    component: AdminLayout,
    children: [
      {
        path: '',
        name: 'EditTournament',
        component: TournamentEditPage,
        props: true,
      }
    ]
  },
  {
    path: '/admin/tournament-activity',
    component: AdminLayout,
    children: [
      { path: '', component: TournamentActivity }
    ]
    //meta: { requiresAdmin: true }  // for admin-only route
  },
  {
    path: '/admin/tournament-activity/create',
    component: AdminLayout,
    children: [
      { path: '', component: TournamentActivityCreatePage }
    ]
    //meta: { requiresAdmin: true }  // admin-only form for menu
  },
  {
    path: '/admin/tournament-activity/edit/:id',
    component: AdminLayout,
    children: [
      {
        path: '',
        name: 'EditActivity',
        component: TournamentActivityEditPage,
        props: true,
      }
    ]
  },
  {
    path: '/admin/tournament-category',
    redirect: '/admin/jenis-tarif'
  },
  {
    path: '/admin/tournament-category/create',
    redirect: '/admin/jenis-tarif'
  },
  {
    path: '/admin/tournament-category/edit/:id',
    redirect: '/admin/jenis-tarif'
  },
  {
    path: '/admin/tournament-age-category',
    component: AdminLayout,
    children: [
      { path: '', component: TournamentAgeCategoryList}
    ]
    //meta: { requiresAdmin: true }  // for admin-only route
  },
  {
    path: '/admin/tournament-age-category/create',
    component: AdminLayout,
    children: [
      { path: '', component: TournamentAgeCategoryCreatePage }
    ]
    //meta: { requiresAdmin: true }  // admin-only form for menu
  },
  {
    path: '/admin/tournament-age-category/edit/:id',
    component: AdminLayout,
    children: [
      {
        path: '',
        name: 'EditCategory',
        component: TournamentAgeCategoryEditPage,
        props: true,
      }
    ]
  },
  {
    path: '/admin/tournament-arena',
    // Admin event juga boleh: rute API-nya dikunci ke turnamennya sendiri.
    meta: { hanyaPanitia: true },
    component: AdminLayout,
    children: [
      { path: '', component: TournamentArenaList }
    ]
    //meta: { requiresAdmin: true }  // for admin-only route
  },
  {
    path: '/admin/tournament-arena/create',
    // Admin event juga boleh: rute API-nya dikunci ke turnamennya sendiri.
    meta: { hanyaPanitia: true },
    component: AdminLayout,
    children: [
      { path: '', component: TournamentArenaCreatePage }
    ]
    //meta: { requiresAdmin: true }  // admin-only form for menu
  },
  {
    path: '/admin/tournament-arena/edit/:id',
    // Admin event juga boleh: rute API-nya dikunci ke turnamennya sendiri.
    meta: { hanyaPanitia: true },
    component: AdminLayout,
    children: [
      {
        path: '',
        name: 'EditArena',
        component: TournamentArenaEditPage,
        props: true,
      }
    ]
  },
  {
    path: '/admin/contact-person',
    component: AdminLayout,
    children: [
      { path: '', component: ContactPersonList }
    ]
    //meta: { requiresAdmin: true }  // for admin-only route
  },
  {
    path: '/admin/contact-person/create',
    component: AdminLayout,
    children: [
      { path: '', component: ContactPersonCreatePage }
    ]
    //meta: { requiresAdmin: true }  // admin-only form for menu
  },
  {
    path: '/admin/contact-person/edit/:id',
    component: AdminLayout,
    children: [
      {
        path: '',
        name: 'EditContactPerson',
        component: ContactPersonEditPage,
        props: true,
      }
    ]
  },
  {
    path: '/admin/tournament-schedule',
    // Admin event juga boleh: rute API-nya dikunci ke turnamennya sendiri.
    meta: { hanyaPanitia: true },
    component: AdminLayout,
    children: [
      { path: '', component: TournamentScheduleList }
    ]
    //meta: { requiresAdmin: true }  // for admin-only route
  },
  {
    path: '/admin/tournament-schedule/tanding/create',
    // Admin event juga boleh: rute API-nya dikunci ke turnamennya sendiri.
    meta: { hanyaPanitia: true },
    component: AdminLayout,
    children: [
      { path: '', component: TournamentScheduleCreatePage }
    ]
    //meta: { requiresAdmin: true }  // admin-only form for menu
  },
  {
    path: '/admin/tournament-schedule/tanding/edit/:id',
    // Admin event juga boleh: rute API-nya dikunci ke turnamennya sendiri.
    meta: { hanyaPanitia: true },
    component: AdminLayout,
    children: [
      {
        path: '',
        name: 'EditScheduleTanding',
        component: TournamentScheduleEditPage,
        props: true,
      }
    ]
  },

  {
    path: '/admin/tournament-schedule/seni/create',
    // Admin event juga boleh: rute API-nya dikunci ke turnamennya sendiri.
    meta: { hanyaPanitia: true },
    component: AdminLayout,
    children: [
      { path: '', component: TournamentScheduleSeniCreatePage }
    ]
    //meta: { requiresAdmin: true }  // admin-only form for menu
  },
  {
    path: '/admin/tournament-schedule/seni/edit/:id',
    // Admin event juga boleh: rute API-nya dikunci ke turnamennya sendiri.
    meta: { hanyaPanitia: true },
    component: AdminLayout,
    children: [
      {
        path: '',
        name: 'EditScheduleSeni',
        component: TournamentScheduleSeniEditPage,
        props: true,
      }
    ]
  },
  {
    path: '/admin/jadwal-kontingen',
    component: AdminLayout,
    children: [
      {
        path: '',
        name: 'ContingentSchedule',
        component: ContingentSchedulePage,
      }
    ]
  },

  {
    path: '/schedule/:slug/tanding',
    component: MainLayout,
    props: true,
    children: [
      {
        path: '',
        name: 'ScheduleTanding',
        component: () => import('@/main/pages/ScheduleTandingPage.vue'),
        props: true
      }
    ]
  },
  {
    path: '/schedule/:slug/seni',
    component: MainLayout,
    props: true,
    children: [
      {
        path: '',
        name: 'ScheduleSeni',
        component: () => import('@/main/pages/ScheduleSeniPage.vue'),
        props: true
      }
    ]
  },
  {
    path: '/schedule/live/:slug/tanding',
    component: MainLayout,
    props: true,
    children: [
      {
        path: '',
        name: 'ScheduleLiveTanding',
        component: () => import('@/main/pages/ScheduleLiveTandingPage.vue'),
        props: true
      }
    ]
  },
  {
    path: '/schedule/live/:slug/seni',
    component: MainLayout,
    props: true,
    children: [
      {
        path: '',
        name: 'ScheduleLiveSeni',
        component: () => import('@/main/pages/ScheduleLiveSeniPage.vue'),
        props: true
      }
    ]
  },

  {
    path: '/kartu-atlet/:id',
    name: 'KartuAtlet',
    component: () => import('@/main/pages/KartuAtletPage.vue'),
    props: true
  },

  // Fallback Catch-all: Mencegah halaman blank jika rute tidak terdaftar
  {
    path: '/:pathMatch(.*)*',
    component: AdminLayout,
    children: [
      {
        path: '',
        name: 'NotFound',
        component: NotFoundPage
      }
    ]
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

/*
 * Bendahara hanya punya layar Keuangan dan Pembayaran. Halaman panitia lain
 * akan ditolak server (403), jadi daripada menampilkan halaman yang kosong
 * dan penuh pesan galat, ia langsung diarahkan ke Keuangan.
 */
router.beforeEach((to) => {
  if (!to.path.startsWith('/admin') || ['/admin/login', '/admin/lupa-sandi'].includes(to.path)) return true;

  if (isBendahara() && !bolehDibukaBendahara(to.path)) {
    return { path: '/admin/payment' };
  }

  // Admin event hanya mengelola kontingen, atlet, dan status pendaftaran.
  if (isAdminEvent() && !bolehDibukaAdminEvent(to.path)) {
    return { path: halamanAwal() };
  }

  // Kartu peserta dicetak panitia; official tidak lagi mencetak sendiri.
  if (to.matched.some((r) => r.meta?.hanyaPanitia) && !isPanitia()) {
    return { path: '/admin/turnamen-saya' };
  }

  if (to.matched.some((r) => r.meta?.hanyaOwner) && !isOwner()) {
    return { path: '/admin' };
  }

  return true;
});

export default router;
